export default __webpack_public_path__ + "static/media/dropdown-arrow.1ce175a0.svg";